module.exports = __webpack_public_path__ + "static/pokoj-nr3-photo01-4099eaec7976357d0ac4fbff95ad88ae.jpg";